import React from "react";
import { motion } from "framer-motion";
import Message from "./Message";

interface UserMessageBlockProps {
  question: string;
  creationDate: string | undefined;
  isLastItem: boolean;
  hasResponse: boolean;
  hasActiveTask: boolean;
  lastMessageRef: React.RefObject<HTMLDivElement>;
}

export const UserMessageBlock: React.FC<UserMessageBlockProps> = ({
  question,
  creationDate,
  isLastItem,
  hasResponse,
  hasActiveTask,
  lastMessageRef,
}) => (
  <motion.div
    initial={{ opacity: 0, x: 20 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.3, ease: "easeOut" }}
    className="w-full"
    ref={isLastItem && !hasResponse && !hasActiveTask ? lastMessageRef : null}
  >
    <Message type="user" message={question} creation_date={creationDate ?? ""} />
  </motion.div>
);
